webpackJsonp([171547189793069],{

/***/ 1357:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ApproveMedicationInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"encounterId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"prescriberId","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-approve-medication-input-5dfd4cbe0e03f79b2531.js